import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";
import { LOGO } from "@/lib/logo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) nav("/admin");
  }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-rainforest flex items-center justify-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-md border border-cream/20 p-10" data-testid="admin-login-form">
        <div className="flex items-center gap-3 mb-2">
          <img src={LOGO.markCream} alt="" className="h-9 w-9 object-contain" />
          <span className="font-serif text-2xl text-cream">SeedKeepers Academy</span>
        </div>
        <p className="overline text-cream/50 mb-8">Content Management</p>
        <label className="block mb-4">
          <span className="overline text-cream/50 mb-2 block">Email</span>
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" required className="w-full bg-transparent border border-cream/25 px-4 py-3 text-cream focus:outline-none focus:border-ochre" />
        </label>
        <label className="block mb-8">
          <span className="overline text-cream/50 mb-2 block">Password</span>
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" required className="w-full bg-transparent border border-cream/25 px-4 py-3 text-cream focus:outline-none focus:border-ochre" />
        </label>
        <button type="submit" disabled={loading} data-testid="admin-login-submit" className="w-full bg-ochre text-cream py-3.5 text-sm tracking-wide hover:bg-copper transition-colors disabled:opacity-60">
          {loading ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
